<ng-container *ngIf="metricsData; else noData">
	<div class="title-icon margin-top-32">
		<span class="text-uppercase text-18-bold" [dcrHTMLKey]="titleDcrKey">Carbon Emissions Impact</span>
		<icon type="info-circle" class="info-circle" [tooltip-dcr]="titleDcrKey + '_TOOLTIP'" [analytic-data]="{ linkName: titleDcrKey + '_TOOLTIP' }"></icon>
	</div>

	<div [dcrHTMLKey]="subtitleDcrKey" class="margin-bottom-24 text-16">
		<span>{{ subtitleDcrKey }}</span>
	</div>
	<section *ngIf="!multiPortfolios" class="single-portfolio-metrics row">
		<div *ngFor="let carbonMetric of metricsData[0]?.metrics" class="col-6 col-md-8 col-sm-12 text-14 margin-bottom-16">
			<div class="carbon-impact padding-32">
				<div>
					<img ada-decorative [remote-src]="carbonMetric?.icon" onerror="this.style.visibility = 'hidden'" />
				</div>
				<p class="margin-top-32 text-20-bold text-align-left">{{ carbonMetric?.metricScore }}</p>
				<p class="text-align-left text-14 carbon-emission-name" [dcrHTMLKey]="'ESG_METRIC_' + carbonMetric?.name + '_LABEL'">
					<span>{{ carbonMetric?.name }}</span>
				</p>
				<icon
					type="info-circle"
					class="info-circle"
					[tooltip-dcr]="'ESG_METRIC_' + carbonMetric?.name + '_TOOLTIP'"
					[analytic-data]="{ linkName: 'ESG_METRIC_' + carbonMetric?.name + '_TOOLTIP' }"
				></icon>
			</div>
		</div>
	</section>

	<section *ngIf="multiPortfolios" class="multi-portfolio-metrics margin-vertical-16 text-14">
		<!-- Header -->
		<div class="row header-container text-bold">
			<div [class]="columnClass1">
				<span dcrHTMLKey="ESG_IMPACT_LABEL">Impact</span>
			</div>
			<div class="metric-column" [class]="columnClass2">
				<div *ngFor="let portfolio of metricsData" class="metric-col-header" [forcedLineBreak]="portfolio?.portfolioName"></div>
			</div>
		</div>

		<!-- Contents -->
		<div class="row metric-container" *ngFor="let metric of metricsData[0].metrics; index as i">
			<div class="impact-col" [class]="columnClass1">
				<img ada-decorative [remote-src]="metric?.icon" onerror="this.style.visibility = 'hidden'" />
				<div class="metric-description">
					<span [dcrHTMLKey]="'ESG_METRIC_' + metric?.name + '_LABEL'">
						<span>{{ metric?.name }}</span>
					</span>
					<icon
						type="info-circle"
						class="info-circle col-2"
						[tooltip-dcr]="'ESG_METRIC_' + metric?.name + '_TOOLTIP'"
						[analytic-data]="{ linkName: 'ESG_METRIC_' + metric?.name + '_TOOLTIP' }"
					></icon>
				</div>
			</div>
			<div class="metric-column" [class]="columnClass2">
				<div *ngFor="let carbonMetric of metricsData">
					<ng-container *ngIf="carbonMetric.metrics[i].name === metric.name">
						<span>
							{{ carbonMetric.metrics[i]?.metricScore }}
						</span>
						<span *ngIf="carbonMetric.metrics[i]?.showUnits" [dcrHTMLKey]="'ESG_METRIC_' + metric?.name + '_UNIT'"></span>
					</ng-container>
				</div>
			</div>
		</div>
	</section>
	<ac-tpm-disclosure></ac-tpm-disclosure>
	<ac-disclosure [isExpandable]="false" [dcrKey]="disclosureDcrKey"></ac-disclosure>
	<ac-disclosure [isExpandable]="false" *ngIf="showAsOfDateDynamic && asOfDate">
		<span dcrHTMLKey="AS_OF_DATE_DYNAMIC" [dcrSubstitutions]="{ asOfDate: asOfDate }">As of asOfDate</span>
	</ac-disclosure>
</ng-container>
<ng-template #noData>
	<dl-no-data [data]="data"></dl-no-data>
</ng-template>
